// extracted by mini-css-extract-plugin
export var card = "_n6-1";
export var summary = "_n6-0";